import { fork, put, takeLatest } from 'redux-saga/effects'

import { createApiCall } from 'services/api'
import { ActionType } from './model'
import { IAxiosResponse } from '../model'

export function* getProfileSaga(): Generator {
  yield takeLatest(ActionType.GET_PROFILE, function* () {
    try {
      const { status, data }: IAxiosResponse = yield createApiCall({
        url: `/account/me`,
      })

      if (status === 200) {
        yield put({
          type: ActionType.SET_PROFILE,
          payload: data,
        })
      }
    } catch (error) {
      // error
    }
  })
}

export default [fork(getProfileSaga)]
